import { useQuery } from 'react-query';
import { getReportReasonsAPI } from '@myme/api';
import { getReportReasons } from '@myme/logic';

export const useGetReportReasons = () => {
  const { data: reasons, isLoading } = useQuery(getReportReasonsAPI.cacheKeys, async () => getReportReasons());

  const reportReasons = reasons?.data ?? [];

  return { reportReasons, isLoading };
};
